import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';
import FormInput from '../FormInput';

function BancontactForm({ t, onAccountHolder, accountName }) {
  const [accountHolderName, setAccountHolderName] = useState(accountName);
  const handleChange = useCallback(value => setAccountHolderName(value), []);

  useEffect(() => {
    onAccountHolder(accountHolderName);
  }, [accountHolderName]);

  return (
    <div className="row">
      <div className="col-lg-12 col-12">
        <FormInput
          label={t('stripe.bancontact.input.label')}
          placeholder={t('stripe.bancontact.input.label')}
          id="accountHolder"
          name="accountHolder"
          containerClassName="col-lg-9 col-12"
          labelClassName="col-lg-3 col-12"
          groupProps={{ className: 'form-group m-form__group row' }}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

BancontactForm.propTypes = {
  t: PropTypes.func.isRequired,
  onAccountHolder: PropTypes.func.isRequired,
  accountName: PropTypes.string,
};

BancontactForm.defaultProps = {
  accountName: null,
};

export default translate(BancontactForm);
